import { useLanguage } from "@/contexts/LanguageContext";
import { CleanTestimonial } from "@/components/ui/clean-testimonial";

const TestimonialsSection = () => {
  const { t } = useLanguage();

  const testimonials = [
    {
      quote: t("testimonials.sarah"),
      author: t("testimonials.sarahName"),
      role: t("testimonials.sarahRole"),
      company: t("testimonials.sarahCompany"),
      avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&h=200&fit=crop&crop=face",
    },
    {
      quote: t("testimonials.michael"),
      author: t("testimonials.michaelName"),
      role: t("testimonials.michaelRole"),
      company: t("testimonials.michaelCompany"),
      avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&fit=crop&crop=face",
    },
    {
      quote: t("testimonials.emma"),
      author: t("testimonials.emmaName"),
      role: t("testimonials.emmaRole"),
      company: t("testimonials.emmaCompany"),
      avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=200&h=200&fit=crop&crop=face",
    },
  ];

  return (
    <section className="pt-16 md:pt-24 pb-16 md:pb-24 px-4 md:px-6 relative overflow-hidden">
      <div className="container mx-auto max-w-6xl relative z-10 pt-12 md:pt-24">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-8 text-center text-glow-hover uppercase">
          {t("testimonials.title")} <span className="text-holographic">{t("testimonials.stories")}</span>
        </h2>

        <div className="glass-card rounded-2xl relative">
          <CleanTestimonial testimonials={testimonials} />
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
